import { Suspense } from 'react'
import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { OpportunityManagementContextProvider } from "@/opportunity/OpportunityManagementContext";
import { usePosthogGroup } from "@/posthog/usePosthogGroup";
import { organizations, useOrganizationMinimal } from "@/organization/api";

export const Route = createFileRoute(
  '/_authenticated/organization/$organizationId',
)({
  component: RouteComponent,
  params: {
    parse: (rawParams) => ({ organizationId: parseInt(rawParams.organizationId)})
  },
  loader: ({ context: { queryClient }, params: { organizationId } }) =>
    queryClient.ensureQueryData(organizations.detailMinimal(organizationId)),
  staticData: {
    breadcrumb: Breadcrumb
  }
})

function RouteComponent() {
  const { organizationId } = Route.useParams();
  const { data: organization } = useOrganizationMinimal(organizationId);

  usePosthogGroup('organization', organization);

  return (
    <Suspense>
      <OpportunityManagementContextProvider organizationId={organization.id}>
        <Outlet />
      </OpportunityManagementContextProvider>
    </Suspense>
  )
}

function Breadcrumb() {
  const { organizationId } = Route.useParams();
  const { data: organization } = useOrganizationMinimal(organizationId);
  return <Link to={Route.fullPath} params={Route.useParams()}>
    {organization.name}
  </Link>
}